import { action, observable, computed } from 'mobx';
import { IThirdPartyToutNodeContent } from '~exported/third-party-tout/ThirdPartyTout';
import { ViewController } from '@estee/elc-service';
import { INodeContent } from '~domain/entities/Node';
import { FindationButtonClickedUseCase } from '~use-cases/FindationButtonClickedUseCase';

export class ThirdPartyToutViewController extends ViewController {
    @observable public _content: Map<number, INodeContent>;

    constructor() {
        super();
        this._content = new Map();
    }

    @action
    public initialize = (props: IThirdPartyToutNodeContent) => {
        this.isLoading = true;
        const { nid, layout, data } = props;
        this.content = {
            nid,
            layout,
            data
        };

        this.isLoading = false;
    };

    public openFindationPopup = (findationKey: string) => {
        const findationButtonClickedUseCase = new FindationButtonClickedUseCase(findationKey);
        findationButtonClickedUseCase.execute();
    };

    @computed
    get data() {
        return {
            content: this._content
        };
    }

    public getContent(nid: number) {
        return this._content.get(nid);
    }

    public set content(input: INodeContent) {
        const { nid } = input;
        this._content.set(nid, { ...input });
    }
}
